import templateUrl from 'emun.vendor/vendor-connections.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import ServiceBus from 'servicestack/service-bus'
import modals from 'webmodals/modals'

class VendorConnectionsController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
		    $ctrl.bus = new ServiceBus();
        if ($ctrl.$session.isRetailer && !$ctrl.vendorId) $ctrl.vendorId = $ctrl.$session.retailerId;
        $ctrl.bus
        .send("QueryVendors.json?Active=1&Id=" + $ctrl.vendorId)
        .then(function(res) {
          if (res.data.results.length > 0) $ctrl.vendor = res.data.results[0];
        });
        $ctrl.getSecret();
    }
    getSecret() {
      const $ctrl = this;
      $ctrl.bus.send("AWS/GetSecret", {
        SecretName: "SFTP/" + $ctrl.vendorId
      }).then(function(response) {
        if (response.data.secretString) $ctrl.secretData = JSON.parse(response.data.secretString);
      });
    }
    generateFtpCredentials() {
      const $ctrl = this;
      $ctrl.bus.send("AWS/GenerateFtpCredentials", {
        VendorId: $ctrl.vendorId
      }).then(function(res) {
        if (res.data.arn) {
          $ctrl.getSecret();
        }
      });
    }
    togglePw() {
      const $ctrl = this;
      $ctrl.isPwReveal = !$ctrl.isPwReveal;
    }
  
}

export default {
	bindings: {
        vendorId: '@'
	},
    controller: VendorConnectionsController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};